// Growem — small centered confirmation dialog (design-system overlay). Used wherever a destructive
// or surprising action needs an explicit, SPECIFIC confirmation (unmark a completed set, undo/redo).
// Backdrop tap and Cancelar both dismiss; the primary button carries the action verb.

import { useEffect, useRef } from 'react'

export default function ConfirmSheet({ title, body, actionLabel, onConfirm, onCancel }: {
  title: string; body: string; actionLabel: string
  onConfirm: () => void; onCancel: () => void
}) {
  const primaryRef = useRef<HTMLButtonElement>(null)
  useEffect(() => {
    primaryRef.current?.focus()
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onCancel() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onCancel])

  return (
    <div role="dialog" aria-modal="true" aria-label={title}
      style={{ position: 'fixed', inset: 0, zIndex: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div onClick={onCancel} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.55)' }} />
      <div className="card" style={{ position: 'relative', width: '100%', maxWidth: 320, padding: 18 }}>
        <div className="kick">{title}</div>
        <p style={{ fontSize: 14, marginTop: 8, lineHeight: 1.45 }}>{body}</p>
        <div className="row" style={{ gap: 10, marginTop: 16, justifyContent: 'flex-end' }}>
          <button className="link" onClick={onCancel} style={{ fontSize: 13, padding: '8px 6px' }}>Cancelar</button>
          <button ref={primaryRef} className="btn" onClick={onConfirm}
            style={{ fontSize: 13, padding: '8px 16px', width: 'auto' }}>{actionLabel}</button>
        </div>
      </div>
    </div>
  )
}
